export function SectionLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-y-5 py-4">
      <div className="w-full space-y-4">{children}</div>
    </div>
  )
}
